import { AgencyBasePackage } from '@smg-real-estate/hg-search-libs';

import hgGoldPartnerBadge from '@/assets/partnerBadge/HG-Gold-Partner.svg?url';
import hgSilverPartnerBadge from '@/assets/partnerBadge/HG-Silver-Partner.svg?url';
import is24GoldPartnerBadge from '@/assets/partnerBadge/IS24-Gold-Partner.svg?url';
import is24SilverPartnerBadge from '@/assets/partnerBadge/IS24-Silver-Partner.svg?url';
import { isPlatformIs24 } from '@/helpers/platformDetection';

export interface PartnerBadge {
  src: string;
  alt: string;
  href: string | null;
}

export function getPartnerBadge(
  basePackage: AgencyBasePackage | null | undefined,
): PartnerBadge | null {
  const normalizedPackage = basePackage?.trim() as AgencyBasePackage | undefined;
  const isIs24 = isPlatformIs24();

  if (
    normalizedPackage === AgencyBasePackage.RE_GOLD ||
    normalizedPackage === AgencyBasePackage.RE_WELCOME
  ) {
    return {
      src: isIs24 ? is24GoldPartnerBadge : hgGoldPartnerBadge,
      alt: 'Gold Partner',
      href: null,
    };
  }

  if (normalizedPackage === AgencyBasePackage.RE_SILVER) {
    return {
      src: isIs24 ? is24SilverPartnerBadge : hgSilverPartnerBadge,
      alt: 'Silver Partner',
      href: null,
    };
  }

  return null;
}
